/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_OrdersInputs */

const en_nav_orders = /** @type {(inputs: Nav_OrdersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orders`)
};

/**
* | output |
* | --- |
* | "Orders" |
*
* @param {Nav_OrdersInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_orders = /** @type {((inputs?: Nav_OrdersInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_OrdersInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_orders(inputs)
});